import React from 'react';
import PropTypes from 'prop-types';
import IMAGE from './images/loading.gif';
import './styles.css';

const Loading = ({ botImage }) => (
  <div className="content-bot">
    <img src={botImage} className="content-image-bot" alt="avatar" />
    <img src={IMAGE} alt="Loading" width="60px" />
  </div>
);

Loading.propTypes = {
  botImage: PropTypes.string.isRequired,
};

export default Loading;
